import React from 'react'

//============== COMPONENTES ==============
import { Button, Grid, Paper, Typography, Box, useMediaQuery, useTheme, Divider } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {
    LocationOn,
    WhatsApp,
    Email
} from '@mui/icons-material';

//============== LEAFLET ==============
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import markerIcon from "leaflet/dist/images/marker-icon.png"
import shadowIcon from "leaflet/dist/images/marker-shadow.png"
import { Icon } from 'leaflet'

//============== ESTILOS MUI ==============
const useStyles = makeStyles((theme) => ({
    container: {
        minHeight: '100vh',
        backgroundColor: theme.palette.background.main,
        padding: '40px 20px',
        [theme.breakpoints.down('sm')]: {
            padding: '20px 10px',
        },
    },
    header: {
        marginBottom: '40px',
        textAlign: 'center',
    },
    mainTitle: {
        fontSize: '3rem',
        fontWeight: 'bold',
        marginBottom: '10px',
        [theme.breakpoints.down('md')]: {
            fontSize: '2.5rem',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '2rem',
        },
    },
    subtitle: {
        fontSize: '1.2rem',
        opacity: 0.8,
        [theme.breakpoints.down('sm')]: {
            fontSize: '1rem',
        },
    },
    mapaContainer: {
        width: '100%',
        height: '100%',
        minHeight: '500px',
        borderRadius: '15px',
        overflow: 'hidden',
        boxShadow: '0px 8px 24px rgba(0,0,0,0.15)',
        [theme.breakpoints.down('md')]: {
            height: '400px',
            minHeight: '400px',
            marginBottom: '20px',
        },
        [theme.breakpoints.down('sm')]: {
            height: '300px',
            minHeight: '300px',
            marginBottom: '20px',
        },
    },
    locationStyle: {
        fontSize: '1rem',
        color: '#189200',
    },
    contactCard: {
        backgroundColor: 'rgba(87,87,87,0.15)',
        backdropFilter: 'blur(10px)',
        borderRadius: '15px',
        padding: '30px',
        boxShadow: '0px 4px 20px rgba(0,0,0,0.1)',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        height: '100%',
        marginLeft: '20px',
        '&:hover': {
            transform: 'translateY(-5px)',
            boxShadow: '0px 8px 30px rgba(0,0,0,0.15)',
        },
        [theme.breakpoints.down('sm')]: {
            padding: '20px',
            marginLeft: '0px',
        },
    },
    sectionTitle: {
        fontSize: '1.5rem',
        fontWeight: 'bold',
        marginBottom: '20px',
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.3rem',
            marginBottom: '15px',
        },
    },
    locationsContainer: {
        display: 'flex',
        gap: '20px',
        marginBottom: '30px',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            gap: '15px',
            marginBottom: '20px',
        },
    },
    locationBox: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
    },
    contactSection: {
        marginTop: '20px',
    },
    contactSubtitle: {
        fontSize: '1.2rem',
        fontWeight: '600',
        marginBottom: '15px',
        opacity: 0.9,
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.1rem',
            marginBottom: '12px',
        },
    },
    contactItem: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '15px',
        gap: '10px',
        [theme.breakpoints.down('sm')]: {
            marginBottom: '12px',
        },
    },
    icon: {
        fontSize: '1.5rem',
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.2rem',
        }
    },
    iconEmail: {
        fontSize: '1.5rem',
        color: '#7a5f00',
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.2rem',
        }
    },
    txtSecondary: {
        fontSize: '1rem',
        textTransform: 'none',
        color: '#000',
        [theme.breakpoints.down('sm')]: {
            fontSize: '0.85rem',
        },
    },
    contactButton: {
        borderRadius: '10px',
        padding: '8px 20px',
        textTransform: 'none',
        [theme.breakpoints.down('sm')]: {
            padding: '6px 15px',
        },
    },
    gridContainer: {
        maxWidth: '1400px',
        margin: '0 auto',
    },
    divider: {
        margin: '25px 0',
        [theme.breakpoints.down('sm')]: {
            margin: '20px 0',
        },
    }
}));

const HowToFindV = () => {
    const classes = useStyles();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));

    //======= Coordenadas para ambas ubicaciones =======
    const cipollettiPosition = [-38.93870593256273, -67.98041909902718];
    const neuquenPosition = [-38.9476059, -68.0554286];
    const centerPosition = [
        (cipollettiPosition[0] + neuquenPosition[0]) / 2,
        (cipollettiPosition[1] + neuquenPosition[1]) / 2
    ];

    //======= Funciones de navegación =======
    const openGoogleMaps = (location) => {
        const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(location)}`;
        window.open(googleMapsUrl, '_blank');
    };

    const openWpp = (type) => {
        const whatsAppNumbers = {
            1: 'https://api.whatsapp.com/send?phone=5492995319130&text=Hola!%20quisiera%20consultar%20por%20los%20cursos',
            2: 'https://api.whatsapp.com/send?phone=5492994231570&text=Hola!%20quisiera%20consultar%20por%20los%20cursos'
        };
        window.open(whatsAppNumbers[type], '_blank');
    };

    const openEmail = (type) => {
        const emails = {
            1: 'mailto:academiamanejar@hotmail.com?subject=Consulta&body=',
            2: 'mailto:sugerencias@academiamanejar.com.ar?subject=Consulta&body='
        };
        window.open(emails[type], '_blank');
    };

    const customIcon = {
        iconUrl: markerIcon,
        shadowUrl: shadowIcon,
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [0, -40],
    };

    const getZoomLevel = () => {
        if (isMobile) return 12;
        if (isTablet) return 13;
        return 13;
    };

    return (
        <Box className={classes.container}>
            <Grid container className={classes.gridContainer}>
                {/* Header */}
                <Grid item xs={12} className={classes.header}>
                    <Typography className={classes.mainTitle}>
                        ¿Cómo encontrarnos?
                    </Typography>
                    <Typography className={classes.subtitle}>
                        Estamos para ayudarte en tus consultas
                    </Typography>
                </Grid>

                {/* Mapa */}
                <Grid item xs={12} md={7}>
                    <Paper elevation={8} className={classes.mapaContainer}>
                        <MapContainer
                            center={centerPosition}
                            minZoom={11}
                            zoom={getZoomLevel()}
                            style={{ height: '100%', width: '100%' }}
                            scrollWheelZoom={true}
                        >
                            <TileLayer
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                            {/* Marker Cipolletti */}
                            <Marker position={cipollettiPosition} icon={new Icon(customIcon)}>
                                <Popup>
                                    <Button className={classes.locationStyle} onClick={() => openGoogleMaps('Alem 1474, Cipolletti, Rio Negro')}>
                                        Alem 1474, <strong>Cipolletti</strong>
                                    </Button>
                                </Popup>
                            </Marker>
                            {/* Marker Neuquén */}
                            <Marker position={neuquenPosition} icon={new Icon(customIcon)}>
                                <Popup>
                                    <Button className={classes.locationStyle} onClick={() => openGoogleMaps('Islas Malvinas 279, Neuquén')}>
                                        Islas Malvinas 279, <strong>Neuquén</strong>
                                    </Button>
                                </Popup>
                            </Marker>
                        </MapContainer>
                    </Paper>
                </Grid>

                {/* Tarjeta única de contacto */}
                <Grid item xs={12} md={5}>
                    <Paper elevation={4} className={classes.contactCard}>
                        <Typography className={classes.sectionTitle}>
                            Nuestras Sucursales
                        </Typography>

                        <Box className={classes.locationsContainer}>
                            <Box className={classes.locationBox}>
                                <LocationOn className={classes.icon} color="error" />
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    className={classes.contactButton}
                                    onClick={() => openGoogleMaps('Alem 1474, Cipolletti, Rio Negro')}
                                    fullWidth
                                >
                                    <Typography className={classes.txtSecondary}>
                                        Alem 1474, Cipolletti, Rio Negro
                                    </Typography>
                                </Button>
                            </Box>

                            <Box className={classes.locationBox}>
                                <LocationOn className={classes.icon} color="error" />
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    className={classes.contactButton}
                                    onClick={() => openGoogleMaps('Islas Malvinas 279, Neuquén')}
                                    fullWidth
                                >
                                    <Typography className={classes.txtSecondary}>
                                        Islas Malvinas 279, Neuquén
                                    </Typography>
                                </Button>
                            </Box>
                        </Box>

                        <Divider className={classes.divider} />

                        <Box className={classes.contactSection}>
                            <Typography className={classes.contactSubtitle}>
                                WhatsApp
                            </Typography>
                            
                            <Box className={classes.contactItem}>
                                <WhatsApp className={classes.icon} color="success" />
                                <Button
                                    variant="contained"
                                    color="success"
                                    className={classes.contactButton}
                                    onClick={() => openWpp(1)}
                                >
                                    <Typography className={classes.txtSecondary}>
                                        (+54) 9 299 5319130
                                    </Typography>
                                </Button>
                            </Box>

                            <Box className={classes.contactItem}>
                                <WhatsApp className={classes.icon} color="success" />
                                <Button
                                    variant="contained"
                                    color="success"
                                    className={classes.contactButton}
                                    onClick={() => openWpp(2)}
                                >
                                    <Typography className={classes.txtSecondary}>
                                        (+54) 9 299 4231570
                                    </Typography>
                                </Button>
                            </Box>
                        </Box>

                        <Divider className={classes.divider} />

                        <Box className={classes.contactSection}>
                            <Typography className={classes.contactSubtitle}>
                                Correo Electrónico
                            </Typography>

                            <Box className={classes.contactItem}>
                                <Email className={classes.iconEmail} />
                                <Button
                                    variant="text"
                                    color="primary"
                                    className={classes.contactButton}
                                    onClick={() => openEmail(1)}
                                >
                                    <Typography className={classes.txtSecondary}>
                                        academiamanejar@hotmail.com
                                    </Typography>
                                </Button>
                            </Box>

                            <Box className={classes.contactItem}>
                                <Email className={classes.iconEmail} />
                                <Button
                                    variant="text"
                                    color="primary"
                                    className={classes.contactButton}
                                    onClick={() => openEmail(2)}
                                >
                                    <Typography className={classes.txtSecondary}>
                                        sugerencias@academiamanejar.com.ar
                                    </Typography>
                                </Button>
                            </Box>
                        </Box>
                    </Paper>
                </Grid>
            </Grid>
        </Box>
    )
}

export default HowToFindV